import React, { useState, useEffect } from "react";
import { DateTimePicker } from "@material-ui/pickers";
import "../../css/datePickerThemeReset.css";
import AlarmIcon from "@material-ui/icons/AddAlarm";
import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import moment from "dayjs";
import * as localforage from "localforage";

const MuiDateTimePicker = props => {
  const [selectedDate, handleDateChange] = useState();
  const { t } = useTranslation("task");
  const { tableDisabled, storedDatePickerValueToLocalforageName } = props;

  const storedValueToLocalforage = async () => {
    // const dateValue = selectedDate.valueOf();
    // const dateMomentInUTC = moment(dateValue).utc();
    // const dateValueInUTC = moment(dateMomentInUTC).format("YYYY-MM-DD HH:mm");
    const dateValueStr = moment(selectedDate).format("YYYY-MM-DD HH:mm");
    await localforage.setItem(
      storedDatePickerValueToLocalforageName,
      dateValueStr
      // dateValueInUTC
    );
  };

  useEffect(() => {
    if (tableDisabled === true) {
      const storedValueToLocalforageInitial = async () => {
        await localforage.setItem(
          storedDatePickerValueToLocalforageName,
          undefined
        );
      };
      storedValueToLocalforageInitial();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableDisabled]);

  useEffect(() => {
    //only store value when the input is not distabled
    if (selectedDate && tableDisabled !== true) {
      storedValueToLocalforage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  return (
    <div className="dateTimePicker-wrapper">
      <DateTimePicker
        ampm={false}
        disabled={tableDisabled}
        variant="inline"
        label={`${t("task.selectADate")}`}
        value={selectedDate}
        disablePast
        onChange={handleDateChange}
        inputFormat="YYYY/MM/DD HH:mm"
        hideTabs
        renderInput={props => <TextField {...props} />}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton disabled={tableDisabled}>
                <AlarmIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    </div>
  );
};

export default MuiDateTimePicker;
